// extracted by mini-css-extract-plugin
export default {"notify-message":"eUcWdOVA","notifySlideIn":"DX6fFkAx","notifyFadeOut":"f4znnVOe"};